import DOMPurify from 'dompurify';

export function toSnakeCase(str) {
  return str.replace(/\s+/g, '_').toLowerCase();
}

export function isSnakeCase(str) {
  return /^[a-z]+(_[a-z]+)*$/.test(str);
}

export function getInitials(name) {
  const words = name.split(' ');

  const initials = words.map((word) => word.charAt(0).toUpperCase());

  return initials.join('');
}

export function fToSnake(inputString) {
  if (!inputString) return '';
  try {
    // Convert the string to lowercase
    const lowercaseString = inputString.toLowerCase();

    // Replace spaces, symbols, and consecutive symbols with underscores
    const formattedString = lowercaseString.replace(/[\s,!@#$%^&*()\-_+=<>.?/|\\]+/g, '_');

    return formattedString;
  } catch (error) {
    return inputString;
  }
}

export function isHTML(variable) {
  const element = document.createElement('div');
  element.innerHTML = variable;
  // Check if the parsed content still contains HTML tags
  return element.childElementCount > 0;
}

const options = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  allowedAttributes: {
    a: ['href'],
  },
  allowedIframeHostnames: ['www.youtube.com'],
};

export const sanitizeHtml = (html) => ({
  __html: DOMPurify.sanitize(html),
});

export const calculateFontSize = (text, baseFontSize = 12, maxLength = 20) => {
  const lengthFactor = Math.min(1, maxLength / text.length);
  const fontSize = baseFontSize * lengthFactor;
  return `${fontSize}px`;
};

export function getRandomColorWhiteText() {
  // Helper function to calculate luminance based on the RGB color
  function getLuminance(r, g, b) {
    const a = [r, g, b].map((v) => {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }

  // Helper function to calculate contrast ratio
  function getContrastRatio(luminance1, luminance2) {
    const L1 = luminance1 + 0.05;
    const L2 = luminance2 + 0.05;
    return L1 > L2 ? L1 / L2 : L2 / L1;
  }

  let r;
  let g;
  let b;
  let luminance;
  let contrastRatio;
  
  const whiteLuminance = getLuminance(255, 255, 255); // Luminance for white text

  // Keep generating random colors until the contrast ratio is high enough
  do {
    r = Math.floor(Math.random() * 256); // Random value for red (0-255)
    g = Math.floor(Math.random() * 256); // Random value for green (0-255)
    b = Math.floor(Math.random() * 256); // Random value for blue (0-255)
    luminance = getLuminance(r, g, b);
    contrastRatio = getContrastRatio(luminance, whiteLuminance);
  } while (contrastRatio < 4.5); // Contrast ratio must be at least 4.5 for accessibility

  return `rgb(${r}, ${g}, ${b})`; // Return the RGB color
}

export const getOtpErrorMessage = (translate, error) => {
  let errorMessage = error?.response?.data?.message || error?.response?.data || error.message;

  if (error?.code) {
    switch (error?.code) {
      case 'auth/invalid-verification-code':
        errorMessage = translate('invalid_verification');
        break;
      case 'auth/code-expired':
        errorMessage = translate('otp_expired');
        break;
      case 'auth/invalid-phone-number' || 'auth/too-many-requests':
        errorMessage = translate('invalid_x', { x: translate('phone_number') });
        break;
      case 'auth/captcha-check-failed':
        errorMessage = translate('captcha_check_failed');
        break;

      default:
        errorMessage = translate('network_error');
        break;
    }
  }

  return errorMessage;
};
